// import store from '../store';
import SearchGards from './guards/seach-guards';
import CompareGards from './guards/compare-guards';

export default (router) => {
  router.beforeEach(async (to, from, next) => {
    if (to.name === 'compareEN' || to.name === 'compareFR') CompareGards(to, from, next);
    else SearchGards(to, from, next);
  });
};
